import { Loader2, PlugZap, RefreshCw, Wifi, WifiOff } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import type { ConnectionStatus as Status } from '@/types/liveview'

const PRESENTATION: Record<
  Status,
  { label: string; variant: 'success' | 'warning' | 'destructive' | 'secondary'; Icon: typeof Wifi }
> = {
  open: { label: 'Live', variant: 'success', Icon: Wifi },
  connecting: { label: 'Connecting', variant: 'warning', Icon: Loader2 },
  reconnecting: { label: 'Reconnecting', variant: 'warning', Icon: Loader2 },
  closed: { label: 'Offline', variant: 'destructive', Icon: WifiOff },
  error: { label: 'Error', variant: 'destructive', Icon: PlugZap },
}

export function ConnectionStatus({
  status,
  onReconnect,
}: {
  status: Status
  onReconnect: () => void
}) {
  const { label, variant, Icon } = PRESENTATION[status]
  const spinning = status === 'connecting' || status === 'reconnecting'

  return (
    <div className="flex items-center gap-1.5">
      <Badge variant={variant} className="gap-1.5 px-2 py-1">
        <Icon className={spinning ? 'animate-spin' : ''} />
        {label}
      </Badge>
      {status !== 'open' && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="ghost" size="icon-sm" onClick={onReconnect} aria-label="Reconnect now">
              <RefreshCw />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Reconnect now</TooltipContent>
        </Tooltip>
      )}
    </div>
  )
}
